// src/js/reducers/index.js
/* import * as actions from "../constants/user-action-types";
import * as userActions from "../actions/user"; */
import moment from "moment";

var date = new Date();

var startDate = moment(date).add(-10, "years");
var endDate = moment(
  new Date()
);

const initialState = {
  usersFilters: {
    dropdownOpen: false,
    startDate: startDate,
    endDate: endDate,
    sources: [
      {
        name: "Google Search",
        key: "Google Search",
        color: "#70bbfd",
        checked: false
      },
      {
        name: "Google Ads",
        key: "Google Ads",
        color: "#4ce1b6",
        checked: false
      },
      {
        name: "Social Media",
        key: "Social Media",
        color: "#CD5C5C",
        checked: false
      },
      {
        name: "Other Ads",
        key: "Other Ads",
        color: "#FFBF00",
        checked: false
      },
      {
        name: "Outbound",
        key: "Outbound",
        color: "#9FE2BF",
        checked: false
      },
      {
        name: "Events",
        key: "Events",
        color: "#DE3163",
        checked: false
      },
      {
        name: "Unknown",
        key: "Unknown",
        color: "#999999",
        checked: false
      },
      {
        name: "Others",
        key: "Others",
        color: "#FF0000",
        checked: false
      }
    ],
    verificationStatus: [
      {
        name: "Verified",
        key: "Verified",
        color: "#70bbfd",
        checked: false
      },
      {
        name: "Not Verified",
        key: "Not Verified",
        color: "#4ce1b6",
        checked: false
      }
    ],
    accountTypes: [
      {
        name: "Owner",
        key: "Owner",
        color: "#70bbfd",
        checked: true
      },
      {
        name: "Staff",
        key: "Staff",
        color: "#4ce1b6",
        checked: false
      }
    ],
    productTypes: [
      {
        name: "Premium",
        key: "Premium",
        color: "#70bbfd",
        checked: false
      },
      {
        name: "Private",
        key: "Private",
        color: "#4ce1b6",
        checked: false
      }
    ],
    statuses: [{
      name: "Activated",
      key: "Activated",
      color: "#70bbfd",
      checked: false
    },
    {
      name: "Trial",
      key: "Trial",
      color: "#f6da6e",
      checked: false
    },
    {
      name: "Trial Expired",
      key: "Trial Expired",
      color: "#f6da6e",
      checked: false
    },
    {
      name: "Paid",
      key: "Paid",
      color: "#4ce1b6",
      checked: false
    },
    {
      name: "Cancellation Requests",
      key: "Cancellation Requests",
      color: "#ff4861",
      checked: false
    },
    {
      name: "Cancelled",
      key: "Cancelled",
      color: "#ff4861",
      checked: false
    },
    {
      name: "Account Closure",
      key: "Account Closure",
      color: "#ff4861",
      checked: false
    }
  ],
  }
};

function rootReducer(state = initialState, action) {
  

  return state;
}

export default rootReducer;